export const LoadSource = {
    donwloadjava: 'Website - Syllabus B2C Java',
    downloadmern: 'Website - Syllabus B2C MERN',
    iwantinfo: 'Website - Quiero Info B2C'
}